//server url
export const BASE_URL = "https://kittima-portfolio-a9950a6de577.herokuapp.com";